import { BaseModel } from "./hateoas/base-model";

export class ManagerAnalyzeModel extends BaseModel {
  descriptionAnalyze?: string;
  managerDealingsUuid?: string;
  managerUuid?: string;
  analyzeUuid?: string;
}
